import { ReactNode, ButtonHTMLAttributes } from "react";
import styled from "styled-components";

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "solid" | "outline";
  children: ReactNode;
}

const StyledButton = styled.button<{ $variant?: string }>`
  display: flex;
  padding: 0 10px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  min-height: 50px;
  border: 1px solid var(--primary-color);
  background-color: ${(props) =>
    props.$variant === "outline"
      ? "var(--bs-body-bg)"
      : "var(--primary-color)"};
  color: ${(props) =>
    props.$variant === "solid" ? "var(--bs-body-bg)" : "var(--primary-color)"};
  width: auto;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;

  &:focus,
  &:active,
  &:hover {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
    color: var(--bs-body-bg);
  }

  &:disabled {
    border-color: var(--primary-color);
    background-color: var(--primary-color);
    color: var(--bs-body-bg);
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

const PrimaryButton = (props: PrimaryButtonProps) => {
  const { children, variant = "solid", type = "submit", ...restProps } = props;

  return (
    <StyledButton type={type} $variant={variant} {...restProps}>
      {children}
    </StyledButton>
  );
};

export default PrimaryButton;
